import { useEffect, useState } from 'react'
import { cn } from '@/lib/utils'
import { Loader } from '../feedback/loader'
import { Modal } from './modal'

interface ImageModalProps {
  isOpen: boolean
  onClose: () => void
  imageUrl: string
  title: string
}

export function ImageModal({ isOpen, onClose, imageUrl, title }: ImageModalProps) {
  const [isImageLoading, setIsImageLoading] = useState(true)

  // Reset loading state when modal opens
  useEffect(() => {
    if (isOpen) {
      setIsImageLoading(true)
    }
  }, [isOpen])

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <div className="relative rounded-lg overflow-hidden bg-black border border-white/10">
        {/* Loading state */}
        {isImageLoading && (
          <div className="flex items-center justify-center bg-black aspect-video">
            <Loader />
          </div>
        )}
        <img
          src={imageUrl}
          alt={title}
          onLoad={() => setIsImageLoading(false)}
          className={cn(
            "w-full max-h-[70vh] object-contain",
            isImageLoading && "hidden"
          )}
        />
      </div>
    </Modal>
  )
}
